import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sessionService } from 'services/session.service';
import { User } from 'lib';
import { Param, ParamTypes, UserForISOD } from 'lib/types';
import { useSelector } from 'react-redux';
import { AppState } from './app';
import _ from 'lodash';

const sessionSlice = createSlice({
    name: 'session',
    initialState: {
        user: null as User | null,
        isFetchingUser: true
    },
    reducers: {
        setUser(state, action: PayloadAction<User | null>) {
            state.user = action.payload;
            sessionService.setToken(action.payload?.token ?? null, action.payload?.tokenExpiration ?? null);
        },
        setUserParams(state, action: PayloadAction<Param[]>) {
            if (state.user !== null) {
                state.user.params = action.payload;
            }
        },
        setIsFetchingUser(state, action: PayloadAction<boolean>) {
            state.isFetchingUser = action.payload;
        },
        setToken(state, action: PayloadAction<string>) {
            if (state.user !== null) state.user.token = action.payload;
        }
    }
});

export default sessionSlice.reducer;

export const sessionActions = sessionSlice.actions;

export const useUser = (): User | null => useSelector((state: AppState) => state.session.user);

export const useUserForISOD = (): UserForISOD => useSelector((state: AppState) => ({
    company: state.session.user?.company ?? '',
    logo: state.session.user?.logo ?? '',
    login: state.session.user?.login ?? '',
    token: state.session.user?.token ?? '',
    tokenExpiration: state.session.user?.tokenExpiration ?? 0
}));

export const useIsFetchingUser = () => useSelector((state: AppState) => state.session.isFetchingUser);

export const useUserParams = () => useSelector((state: AppState) => state.session.user?.params);

export const useUserParam = (param: ParamTypes) => useSelector((state: AppState) => {
    if (state.session.user === null) {
        return null;
    }
    const userParam = _.filter((state.session.user.params as Param[]), { ParamName: param });
    return userParam[0].ParamValue;
});
